export default __webpack_public_path__ + "static/no-image-094042b82e89e6d1f5c1ca9bb8b9f637.png";